import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonProps, createPolymorphicComponent } from '@mantine/core';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { UniqueIdentifier } from '@vision/ui/interfaces';
import { DragAndDropListHandleContext } from '../DragAndDropListHandleContext';
import classes from './DraggableListItemHandle.module.css';

type DragHandleProps = {
  handleRef?: (element: Element | null) => void;
  id: UniqueIdentifier;
} & ButtonProps;

function _DraggableListItemHandle({ children, handleRef: handleRefProp, id, className, ...others }: DragHandleProps) {
  const contextHandleRef = useContext(DragAndDropListHandleContext);

  return (
    <Button
      className={clsx(classes.draggableListItemHandle, className)}
      data-dnd-kit-handle-id={id}
      ref={handleRefProp || contextHandleRef}
      size="compact-xs"
      color="dark"
      variant="subtle"
      {...others}
    >
      {children || <FontAwesomeIcon icon={faGripDotsVertical} />}
    </Button>
  );
}

export const DraggableListItemHandle = createPolymorphicComponent<'button', DragHandleProps>(
  React.memo(_DraggableListItemHandle),
);
